import { Modal } from 'reactstrap';
import styles from './ManageAccounts.module.scss';
import { IoMdClose as CloseIcon } from 'react-icons/io'
import { useEffect, useMemo, useState } from 'react';
import { RestS } from '../../../rest/rest-service';
import CircularLoader from '../../../components/common/CircularLoader/CircularLoader';
import { RiDeleteBin6Line as DeleteIcon } from 'react-icons/ri'
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';
import { FaCircleExclamation as Exclamation } from "react-icons/fa6";
import { useAppDispatch, useAppSelector } from '../../../redux/reduxHooks';
import { JobType, LoadingProgressType } from '../../../interfaces/interfaces';
import { IpRestS } from '../../../rest/ipRest-service';
import { fetchCurrentConnections } from '../../../redux/connections/connSlice';

type Props = {
    isOpen: boolean;
    setOpen: (value: boolean) => void;
    closePopup: (fetchTabs?: boolean) => void;
    ipName: string;
    ipLogo: string;
    fsMetricId: number;
}

const initialDeleteItem = { accessTokenId: null, isConnected: false };

const ManageAccounts = ({ isOpen, setOpen, closePopup, ipName, ipLogo, fsMetricId }: Props) => {
    const [loading, setLoading] = useState(false);
    const [allAccounts, setAllAccounts] = useState({ connectedAccounts: [], disconnectedAccounts: [] });
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [deleteItem, setDeleteItem] = useState(initialDeleteItem);
    const [deleteBtnLoading, setDeleteBtnLoading] = useState(false);
    const dispatch = useAppDispatch();
    const { integrationPartners } = useAppSelector(state => state.config);


    const fetchAllAcounts = async () => {
        try {
            const data: any = await RestS.getAccountsByIpName(ipName);
            setAllAccounts({ connectedAccounts: data?.connectedAccounts, disconnectedAccounts: data?.disconnectedAccounts })
        } catch (error) {
            console.log('Error fetching accounts', error);
        }
    }



    useEffect(() => {
        // fetch all accounts
        (async () => {
            setLoading(true);
            await fetchAllAcounts();
            setLoading(false);
        })();
    }, []);

    const deleteAccount = async (accessTokenId: number, isConnected: boolean) => {
        try {
            setDeleteBtnLoading(true);
            if (!isConnected) {
                const bodyData = {
                    ipName,
                    extraConfig: {
                        fsMetricId
                    },
                    accessTokenId,

                }
                const data: any = await RestS.deleteAccountFromFs(bodyData);
                fetchAllAcounts();
            } else {
                const currentIpDetails = integrationPartners[ipName]
                IpRestS.uninstallUser(currentIpDetails?._id, ipName, accessTokenId)
                    .then(async (res) => {
                        dispatch(fetchCurrentConnections({}));
                        RestS.refreshNow({
                            ip: currentIpDetails,
                            jobType: JobType.refreshNow
                        });
                        // RestS.regenerateInsights();
                        const bodyData = {
                            ipName,
                            extraConfig: {
                                fsMetricId
                            },
                            accessTokenId,

                        }
                        const data: any = await RestS.deleteAccountFromFs(bodyData);
                        fetchAllAcounts();
                    })
                    .catch((err) => {
                        dispatch(fetchCurrentConnections({}));
                    });
            }
        } catch (error) {
            console.log('Error deleting account', error)
        } finally {
            setDeleteBtnLoading(false);
            setShowDeleteConfirmation(false);
            setDeleteItem(initialDeleteItem)
        }
    }

    const handleDeleteConfirmation = (accessTokenId: number, isConnected: boolean) => {
        setShowDeleteConfirmation(true);
        setDeleteItem({ accessTokenId, isConnected });
    }




    return (
        <Modal size='md' centered isOpen={isOpen} toggle={() => {
            closePopup();
        }}>
            <div className={styles.rootContainer}>
                <div className={styles.headerContainer}>
                    <div className={styles.leftContainer}>
                        <div className={styles.ipLogo}>
                            <img src={ipLogo} alt="" />
                        </div>
                        <div className={styles.headerTitle}>
                            Manage Ad Accounts
                        </div>
                    </div>
                    <div className={styles.rightContainer}>
                        <MeritoButton type='secondary-1' icon={<CloseIcon />} onlyIcon={true} onClick={() => closePopup()} />
                    </div>
                </div>
                <div className={styles.bodyContainer}>
                    {loading ?
                        <div className={styles.loadingContainer}>
                            <CircularLoader
                            />
                        </div>
                        :
                        <div className={styles.accountsRootContainer}>
                            {allAccounts?.connectedAccounts && allAccounts?.connectedAccounts.length ?
                                <div className={styles.accountsContainer}>
                                    <div className={styles.accountsHeaderContainer}>
                                        <div className={`${styles.statusContainer} ${styles.active}`}>

                                        </div>
                                        <div className={styles.accountHeaderTitle}>
                                            Connected Accounts
                                        </div>
                                    </div>
                                    <div className={styles.accountsList}>
                                        {allAccounts.connectedAccounts.map((account: any, index: number) => {
                                            return (
                                                <div key={index} className={styles.accountItem}>
                                                    <div className={styles.leftContainer}>

                                                        {account.storeName ? (
                                                            <>
                                                                <div className={styles.accountTitle}>{account.storeName}</div>
                                                                {account.customer_name ? (
                                                                    <div className={styles.accountSubtitle}>{account.customerName}</div>
                                                                ) : null}
                                                            </>
                                                        ) : account.clientId || account.clientName ? (
                                                            account.clientName ? (
                                                                <>
                                                                    <div className={styles.accountTitle}>{account.clientName}</div>
                                                                    <div className={styles.accountSubtitle}>{account.clientId}</div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className={styles.accountTitle}>{account.clientId}</div>
                                                                </>
                                                            )
                                                        ) : account.customerName ? (
                                                            <>
                                                                <div className={styles.accountTitle}>{account.customerName}</div>
                                                                <div className={styles.accountSubtitle}>{account.customerId}</div>
                                                            </>
                                                        ) : (
                                                            <div className={styles.accountTitle}>{account.customerId}</div>
                                                        )}
                                                    </div>
                                                    <div className={styles.rightContainer}>
                                                        <MeritoButton type='destructive-ghost' onlyIcon={true} icon={<DeleteIcon />} onClick={() => handleDeleteConfirmation(account?.id, true)} />
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                                : null}

                            {allAccounts?.disconnectedAccounts && allAccounts?.disconnectedAccounts.length ?
                                <div className={styles.accountsContainer}>
                                    <div className={styles.accountsHeaderContainer}>
                                        <div className={`${styles.statusContainer} ${styles.inactive}`}>

                                        </div>
                                        <div className={styles.accountHeaderTitle}>
                                            Disconnected Accounts
                                        </div>
                                    </div>
                                    <div className={styles.accountsList}>
                                        {allAccounts.disconnectedAccounts.map((account: any, index: number) => {
                                            return (
                                                <div key={index} className={styles.accountItem}>
                                                    <div className={styles.leftContainer}>
                                                        {account.storeName ? (
                                                            <>
                                                                <div className={styles.accountTitle}>{account.storeName}</div>
                                                                {account.customer_name ? (
                                                                    <div className={styles.accountSubtitle}>{account.customerName}</div>
                                                                ) : null}
                                                            </>
                                                        ) : account.clientId || account.clientName ? (
                                                            account.clientName ? (
                                                                <>
                                                                    <div className={styles.accountTitle}>{account.clientName}</div>
                                                                    <div className={styles.accountSubtitle}>{account.clientId}</div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <div className={styles.accountTitle}>{account.clientId}</div>
                                                                </>
                                                            )
                                                        ) : account.customerName ? (
                                                            <>
                                                                <div className={styles.accountTitle}>{account.customerName}</div>
                                                                <div className={styles.accountSubtitle}>{account.customerId}</div>
                                                            </>
                                                        ) : (
                                                            <div className={styles.accountTitle}>{account.customerId}</div>
                                                        )}
                                                    </div>
                                                    <div className={styles.rightContainer}>
                                                        <MeritoButton type='destructive-ghost' onlyIcon={true} icon={<DeleteIcon />} onClick={() => handleDeleteConfirmation(account?.id, false)} />
                                                    </div>

                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>

                                : null}



                        </div>
                    }
                </div>
            </div>

            <ConfirmDialog
                modalStyles={{ maxWidth: '450px' }}
                showButton={false}
                visible={showDeleteConfirmation}
                toggle={() => {
                    setShowDeleteConfirmation(!showDeleteConfirmation);
                }}
                showCloseBtn={false}
                size={"md"}
            >
                <div className={styles.confirmationContainer}>
                    <div className={styles.topContainer}>
                        <div className={styles.iconContainer}>
                            <Exclamation />
                        </div>
                        <div className={styles.title}>
                            Delete Account Data ?
                        </div>

                        <div className={styles.warningText}>
                            Data from this account will be permanently deleted from your P&L.
                            <br />
                            <br />
                            This may take up to 10 minutes.
                        </div>
                    </div>

                    <div className={styles.bottomContainer}>
                        <MeritoButton onClick={() => setShowDeleteConfirmation(!showDeleteConfirmation)} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText="Cancel" />
                        <MeritoButton loading={deleteBtnLoading} size="lg" onClick={() => {
                            deleteAccount(deleteItem.accessTokenId, deleteItem.isConnected)
                        }} isRounded={true} btnType="button" type="primary-1" btnText="Delete Account" />
                    </div>
                </div>
            </ConfirmDialog>
        </Modal>
    );
}

export default ManageAccounts